import * as Yup from 'yup'
import { cmsGalleryItemWidgetSchemaValidation } from './GalleryItem'

export const gallerySchemaValidation = Yup.object().shape({
  content: Yup.object().shape({
    title: Yup.string().label('Title').trim(),
    cmsGalleryWidgetItems: cmsGalleryItemWidgetSchemaValidation,
  }),
})
